var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StreamPlatformForm',{attrs:{"platform-key":'youtube',"close-modal":_vm.closeModal,"cast-details":_vm.castDetails,"step-three-props":_vm.stepThreeProps,"handle-edit-cast":_vm.handleEditCast}})}
var staticRenderFns = []

export { render, staticRenderFns }